import { connect } from "react-redux";

import { Lead } from "@mapmycustomers/shared/types/entity";

import GenericLeadItem from "@app/component/LeadItem";
import { EntityItemProperties } from "@app/component/RecordCard";
import {
  setLeadAnnotation,
  showDuplicates,
  toggleSelectedItem,
} from "@app/scene/map/store/actions";
import { isRecordSelected } from "@app/scene/map/store/selectors";
import { RootState } from "@app/store/rootReducer";
import { leadIdGetter } from "@app/util/map/idGetters";

interface OwnProps extends EntityItemProperties<Lead> {}

const mapStateToProps = (state: RootState, { entity }: OwnProps) => ({
  selected: isRecordSelected(state, leadIdGetter(entity)),
});

const mapDispatchToProps = {
  onSetAnnotation: setLeadAnnotation,
  onWarningClick: showDuplicates,
  toggleSelectedItem,
};

const LeadItem = connect(mapStateToProps, mapDispatchToProps)(GenericLeadItem);

export default LeadItem;
